import React from "react";

export function TournamentHeader({ competition, teams }) {
    const teamIds = Object.keys(teams);

    const svgIconSrc = function (organiser) {
        if (!organiser) {
            return;
        }
        return (
            "https://resources.nextcaddy.com/clubResources/" + organiser + "/logos/SVG/" + organiser + "C.svg"
        );
    };

    return (
        <div
            className={`
        mb-2 h-full rounded-lg bg-white px-4 py-2 w-full max-w-7xl mx-auto shadow-md space-y-6
        lg:flex lg:flex-col lg:items-start lg:px-6 lg:py-8 lg:space-y-8 lg:items-center xl:items-center 2xl:items-center
      `}
        >
            <div
                className={`
          flex flex-col-reverse w-full max-w-7xl mx-auto mb-1 sm:mb-4 sm:flex-row items-center justify-between min-w-0
          lg:flex-col-reverse lg:items-center xl:items-center 2xl:items-center lg:mb-10
        `}
            >
                <div className="flex flex-col-reverse">
                    <h2 className="text-sm text-slate-300 text-center sm:text-left lg:text-center sm:text-base lg:text-sm xl:text-sm 2xl:text-2xl font-semibold uppercase tracking-wide m-1 sm:m-0 sm:mb-2">
                        {competition.organiserName}
                    </h2>
                    <h1 className="text-2xl text-slate-600 text-center sm:text-left lg:text-center sm:text-2xl lg:text-lg xl:text-xl 2xl:text-5xl font-bold uppercase tracking-wide m-1 sm:m-0 lg:mt-6 pb-2">
                        {competition.name}
                    </h1>
                </div>
                <img
                    className="h-6 sm:h-6 m-2 lg:mt-3 lg:block lg:mx-auto lg:h-7 xl:h-9 2xl:h-9 opacity-30"
                    src="https://assets.codepen.io/261257/LOGO_SIMPLE_2023_72_LS.svg"
                    alt="Logo nxt"
                />
            </div>

            <div className="w-full max-w-7xl mx-auto overflow-hidden rounded-lg sm:mb-0">
                <div
                    className={`
            flex flex-row sm:flex-row gap-4 sm:gap-8
            lg:flex-col lg:gap-6
          `}
                >
                    {teamIds.map((teamId, idx) => {
                        const classes = [
                            "flex-1 min-w-0 flex items-center justify-between px-2 py-1.5 rounded-lg flex-row team-header-green",
                            "flex-row",
                            idx === 1 && "flex-row-reverse lg:flex-row",
                            `team-header-${teams[teamId].color}`,
                        ]
                            .filter(Boolean)
                            .join(" ");

                        return (
                            <div key={teamId} className={classes}>
                                <h2 className="text-lg font-semibold m-2 xl:text-xl 2xl:text-3xl">
                                    {teams[teamId].name}
                                </h2>
                                <div className="text-3xl sm:text-3xl lg:py-1 xl:text-3xl 2xl:text-6xl font-bold m-2">
                                    {teams[teamId].score.general}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className="hidden mt-6 lg:mt-8 w-1/2 mx-auto
                outline-solid outline-white outline-[5px]
                outline-offset-[-5px] lg:flex"
            >
                <video autoPlay muted loop className="h-full w-full">
                    <source src="/video/publi.mp4" type="video/mp4" />
                    Tu navegador no soporta el vídeo.
                </video>
            </div>
            <div className="hidden mt-3 lg:mt-4 w-1/2 mx-auto 2xl:flex"
            >
                <img src="/img/frontend/livescoring/logo_pareja_2.png" alt="Descripción de la imagen"/>
            </div>
        </div>
    );
}
